import moment from 'moment'
import Vue from 'vue'
function arrayWithoutId(arr, id) {
  return arr.filter(el => el.id !== id)
}

const compareDateKey = (sortBy, format) => (a, b) => {
  const aMoment = moment(a[sortBy], format)
  const bMoment = moment(b[sortBy], format)

  return bMoment.diff(aMoment)
}

export default {
  setUnitPlans(state, [revenueType, data]) {
    state[revenueType].plans = data
  },
  setUnitPlanFilters(state, [revenueType, data]) {
    state[revenueType].filters = data
  },
  setUnitPlansCounter(state, [revenueType, data]) {
    state[revenueType].counter = data
  },
  appendUnitPlans(state, [revenueType, data]) {
    state[revenueType].plans.unshift(data)
    if (revenueType === 'manicure' || revenueType === 'pedicure') {
      state[revenueType].plans = state[revenueType].plans
        .slice()
        .sort(compareDateKey('begin_at', Vue.config.format.serverDateFull))
    }
  },
  updateUnitPlans(state, [revenueType, data]) {
    state[revenueType].plans = data
  },
  changeUnitPlan(state, { revenueType, data, removingRevenue = false }) {
    state[revenueType].plans = arrayWithoutId(state[revenueType].plans, data.id)
    if (!removingRevenue) {
      state[revenueType].plans = [data, ...state[revenueType].plans]
    }
  },
}
